import {
  AppBar,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import api from "../../../../../Apis";
import DialogSelectFanpages from "../../Fanpages/Posts/Components/DialogSelectFanpages";

const DialogFanpageList = ({
  isOpen,
  onClose,
  fanpagesSelected,
  setFanpagesSelected,
  cookie,
  trainingHistotyList,
  setTrainingHistoryList,
  setIsUpdateFanpageInVectorLoading,
  listFanpages,
  gptVectorId,
  setGptVectorId,
}) => {
  const { t } = useTranslation();
  const initialFanpagesRef = useRef([]);
  const handleRemoveFanpageFromVector = ({ fanpage_id, gpt_vector_id }) => {
    Swal.fire({
      title: "Bạn có chắc chắn muốn xóa fanpage này khỏi lịch sử huấn luyện?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("common.alert.confirm"),
      cancelButtonText: t("common.alert.cancel"),
      confirmButtonColor: "#d33",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsUpdateFanpageInVectorLoading(true);
        const requestOptions = {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + cookie,
          },
        };
        fetch(
          api.gpt_assistant_remove_fanpage_from_vector +
            `?fanpage_id=${fanpage_id}&gpt_vector_id=${gpt_vector_id}`,
          requestOptions
        )
          .then((res) => res.json())
          .then((result) => {
            if (result.success) {
              const filteredFanpages = fanpagesSelected.filter(
                (fanpage) => fanpage.fanpage_id !== fanpage_id
              );
              setFanpagesSelected(filteredFanpages);
              // Cập nhật lại danh sách trainingHistotyList
              const updatedTrainingHistoryList = trainingHistotyList.map(
                (history) => {
                  if (history.id === gpt_vector_id) {
                    return {
                      ...history,
                      fanpages: history.fanpages.filter(
                        (fanpage) => fanpage.fanpage_id !== fanpage_id
                      ),
                    };
                  }
                  return history;
                }
              );
              setTrainingHistoryList(updatedTrainingHistoryList);
              Swal.fire(
                result?.message || t("common.message.deleteSuccess"),
                "",
                "success"
              );
            } else {
              Swal.fire(
                result?.message || t("common.message.pleaseTryAgain"),
                "",
                "error"
              );
            }
          })
          .finally(() => {
            setIsUpdateFanpageInVectorLoading(false);
          });
      }
    });
  };
  const handleAddFanpageToVector = ({ fanpages, gpt_vector_id }) => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + cookie,
      },
      body: JSON.stringify({
        fanpage_ids: fanpages.map((fanpage) => fanpage.fanpage_id),
        gpt_vector_id,
      }),
    };
    setIsUpdateFanpageInVectorLoading(true);
    fetch(api.gpt_assistant_add_fanpage_to_vector, requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          setIsUpdateFanpageInVectorLoading(false);
          // Cập nhật lại danh sách trainingHistotyList
          const updatedTrainingHistoryList = trainingHistotyList.map(
            (history) => {
              if (history.id === gpt_vector_id) {
                return {
                  ...history,
                  fanpages: [...history.fanpages, ...fanpages],
                };
              }
              return history;
            }
          );
          setTrainingHistoryList(updatedTrainingHistoryList);
          Swal.fire(
            result?.message || t("common.message.addSuccess"),
            "",
            "success"
          );
        } else {
          Swal.fire(
            result?.message || t("common.message.pleaseTryAgain"),
            "",
            "error"
          );
        }
      })
      .finally(() => {
        setIsUpdateFanpageInVectorLoading(false);
      });
  };

  useEffect(() => {
    if (isOpen) {
      initialFanpagesRef.current = fanpagesSelected.map((f) =>
        f.fanpage_id.toString()
      );
    }
  }, [isOpen]);
  return (
    <Dialog open={isOpen} fullWidth="true" maxWidth="sm" onClose={onClose}>
      {/* <DialogTitle>{"Danh sách fanpage"}</DialogTitle>
       */}
      <AppBar sx={{ position: "relative" }} color="inherit">
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Danh sách fanpage
          </Typography>
          <DialogSelectFanpages
            listFanpages={listFanpages}
            handleChangeFanpage={(newFanpages) => {
              const validFanpages = newFanpages.filter(
                (fanpage) => fanpage.fanpage_id !== -1
              );

              const initialIds = initialFanpagesRef.current;

              const newlyAddedFanpages = validFanpages.filter(
                (fanpage) => !initialIds.includes(fanpage.fanpage_id.toString())
              );

              if (newlyAddedFanpages.length === 0) return;

              handleAddFanpageToVector({
                fanpages: newlyAddedFanpages,
                gpt_vector_id: gptVectorId,
              });

              setFanpagesSelected(validFanpages);
            }}
            fanpageSelected={fanpagesSelected.map((fanpage) => ({
              fanpage_id: fanpage.fanpage_id.toString(),
              name: fanpage.name || fanpage.fanpage_name,
            }))}
          />
        </Toolbar>
      </AppBar>
      <DialogContent>
        {fanpagesSelected && fanpagesSelected.length > 0 ? (
          fanpagesSelected.map((fanpage, index) => (
            <Chip
              key={fanpage.id}
              label={fanpage.name || fanpage.fanpage_name}
              sx={{ margin: "0 5px 5px 0" }}
              onDelete={() => {
                handleRemoveFanpageFromVector({
                  fanpage_id: fanpage.fanpage_id,
                  gpt_vector_id: gptVectorId,
                });
              }}
            />
          ))
        ) : (
          <Typography
            sx={{
              textAlign: "center",
              fontStyle: "italic",
            }}
          >
            {t("common.message.emptyData")}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.close")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogFanpageList;
